<template>
  <section class="about-panel">
    <header><img :src="projectBrand.icon_url" :alt="projectBrand.name"><h3>{{ projectBrand.name }}</h3></header>
    <dl>
      <div><dt>{{ language.t('about.version') }}</dt><dd>{{ version }}</dd></div>
      <div><dt>{{ language.t('about.client') }}</dt><dd>{{ clientType }}</dd></div>
      <div v-if="shellVersion"><dt>{{ language.t('about.shellVersion') }}</dt><dd>{{ shellVersion }}</dd></div>
      <div><dt>{{ language.t('about.website') }}</dt><dd>{{ website }}</dd></div>
    </dl>
  </section>
</template>
<script setup>
import {computed} from 'vue';
import {appConfig} from '@/config';
import {projectBrand} from '@/services/projectBrand';
import {useLanguageStore} from '@/stores/language';
import {appAssetName} from '@/utils/appVersion.mjs';
const language=useLanguageStore();
const h5=document.documentElement.dataset.buildTarget==='h5';
const asset=Array.from(document.scripts).map(script=>appAssetName(script.src)).find(Boolean)||'';
const version=asset?`${h5?'H5':'Web'}-${asset.replace(/^app\./i,'').replace(/\.js$/i,'')}`:language.t('about.unavailable');
const installed=['standalone','minimal-ui','fullscreen'].some(mode=>window.matchMedia(`(display-mode: ${mode})`).matches)||Boolean(navigator.standalone);
const clientType=computed(()=>language.t(appConfig.capacitorApp?'about.native':installed?'about.installed':h5?'about.h5':'about.web'));
const shellVersion=appConfig.capacitorApp?(navigator.userAgent.match(/JCIM-Capacitor\/([\w.-]+)/)?.[1]||''):'';
const website=new URL(appConfig.serviceOrigin).origin;
</script>
<style scoped>
.about-panel{display:grid;gap:24px}.about-panel header{display:flex;align-items:center;gap:14px}.about-panel header img{width:56px;height:56px;object-fit:contain;border-radius:12px}.about-panel h3{margin:0}.about-panel dl{display:grid;gap:18px;margin:0}.about-panel dl>div{display:grid;grid-template-columns:110px minmax(0,1fr);gap:12px}.about-panel dt{color:var(--muted)}.about-panel dd{margin:0;overflow-wrap:anywhere;user-select:text}@media(max-width:480px){.about-panel dl>div{grid-template-columns:90px minmax(0,1fr)}}
</style>
